export const emailRegex =
	/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export const upcRegex = /^\d{8,14}$/;
export const linkRegex = /^(ftp|http|https):\/\/[^ "]+$|^www\.[^ "]+\.[^ "]+$/;
export const rssRegex =
	/^(https?:\/\/)(?:www\.)?([\w.-]+\.[a-z]{2,})(?:\/[^\s]*)?(?:\/(feed|rss)(\.xml)?)?$/i;

export const isrcRegex = /^[A-Z0-9]{5}\d{7}$/;
export const deezerRegex = /@deezer\.com$/;

export const deezerLinkRegexes = {
	short: /^(https:\/\/)?link.deezer.com\/s\/\w*(\?.*)?$/,
	album: /^(https:\/\/)?www.deezer.com\/([^/]*\/)?album\/\d+(\?.*)?$/,
	artist: /^(https:\/\/)?www.deezer.com\/([^/]*\/)?artist\/\d+(\?.*)?$/,
	playlist: /^(https:\/\/)?www.deezer.com\/([^/]*\/)?playlist\/\d+(\?.*)?$/,
	track: /^(https:\/\/)?www.deezer.com\/([^/]*\/)?track\/\d+(\?.*)?$/,
	user: /^(https:\/\/)?www.deezer.com\/([^/]*\/)?profile\/\d+(\?.*)?$/,
	podcast: /^(https:\/\/)?www.deezer.com\/([^/]*\/)?show\/\d+(\?.*)?$/,
	episode: /^(https:\/\/)?www.deezer.com\/([^/]*\/)?episode\/\d+(\?.*)?$/,
};
